import React, { useState, useRef, useEffect } from "react";
import DataTable from "react-data-table-component";
import { endPoints } from "../../../constant/Environment";
import {
  addData,
  deleteData,
  getAllData,
  fetchAllData,
} from "../../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../../redux/Actions/Actions";
import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import PageHeader from "../../../components/PageHeader";
import DeleteModel from "../../../components/DeleteModel";

import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
import { AiTwotoneEyeInvisible, AiFillEyeInvisible } from "react-icons/ai";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment-timezone";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";

import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import { ArrowUpward, ArrowDownward } from '@mui/icons-material';

function TablePaginationActions(props) {




  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const Provider = () => {

  const [editData, setEditData] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [rowDataToDelete, setRowDataToDelete] = useState(false);

  const [createData, setCreateData] = useState(false);

  const [providerName, setProvideName] = useState("");
  const [commisionRate, setCommisionRate] = useState("");
  const [apiData, setApi] = useState("");
  const [wagerBack, setWagerBack] = useState("");
  const [menuOrder, setMenuOrder] = useState("");

  const [checkboxes, setCheckboxes] = useState({
    isCheckedGoldCoin: false,
    isCheckedSagaCoin: false,
    isCheckedAllowReward: false,
    isCheckedMenu: false,
    isCheckedActive: false,
  });
  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [name]: checked,
    }));
  };

  const [pending, setPending] = useState(true);
  const [show, setShow] = useState(false);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleClose = () => setShow(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    // api call
    fetchProviderList();
  }, []);

  const fetchProviderList = async () => {
    let url = `${endPoints.api.GETPROVIDERS}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          setRows(response.data);
          setPending(false);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const handleOk = () => {

    if (providerName && commisionRate && apiData && wagerBack && menuOrder) {
      let url = editData?.id
        ? `${endPoints.api.UPDATEPROVIDERS}`
        : `${endPoints.api.ADDPROVIDERS}`;

      let payload = {
        provider_name: providerName,
        comission_rate: commisionRate,
        api_url: apiData,
        wager_rewards: wagerBack,
        menu_sort_order: menuOrder,
        goldcoin: checkboxes.isCheckedGoldCoin ? 1 : 0,
        sagacoin: checkboxes.isCheckedSagaCoin ? 1 : 0,
        allow_rewards: checkboxes.isCheckedAllowReward ? 1 : 0,
        is_menu: checkboxes.isCheckedMenu ? 1 : 0,
        isactive: checkboxes.isCheckedActive ? 1 : 0,
      };

      if (editData?.id) {
        payload.id = editData.id;
      }
      setIsLoading(true);
      addData(url, payload)
        .then((response) => {
          setIsLoading(false);
          if (response.data.status === "success") {
            SuccesToast(response?.data?.message);
            fetchProviderList();

            handleClose();
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.error(error);
          ErrorToast(error);
        });
    }
    else {
      ErrorToast("all fields are required");
    }
  };
  // Edit Data Functionality
  useEffect(() => {
    if (editData) {
      setProvideName(editData.provider_name || '');
      setCommisionRate(editData.comission_rate || '');
      setApi(editData.api_url || '');
      setWagerBack(editData.wager_rewards || '');
      setMenuOrder(editData.menu_sort_order || '');
      setCheckboxes((prevCheckboxes) => ({
        ...prevCheckboxes,
        isCheckedGoldCoin: (editData.goldcoin || false),
        isCheckedSagaCoin: (editData.sagacoin || false),
        isCheckedAllowReward: (editData.allow_rewards || false),
        isCheckedMenu: (editData.is_menu || false),
        isCheckedActive: (editData.isactive || false),
      }));
    }
  }, [editData]);



  const handleDelete = (row) => {
    setRowDataToDelete(row);
    setShowDeleteModal(true);
  };

  // Delete Data Functionality
  const deleteProvider = () => {

    const id = rowDataToDelete.id;
    let url = `${endPoints.api.DELETE_PROVIDERS}${id}`;
    setIsLoading(false);
    deleteData(url)
      .then((response) => {
        console.log("update_Res", response);
        setIsLoading(false);
        if (response.status == 200) {
          fetchProviderList();
          setShowDeleteModal(false);
          SuccesToast("Deleted Successfully")

        } else {
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  }

  const handleSwitchChange = (row, param, value) => {

    const updatedRow = { ...row, [param]: value === 0 ? 1 : 0 };
    updateProvider(updatedRow)

  };

  const updateProvider = (payload) => {

    const id = payload.id;
    let url = `${endPoints.api.UPDATEPROVIDERS}`;
    setIsLoading(true);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          fetchProviderList();

          handleClose();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  }

  // Provider Filter 
  const [filteredRows, setFilteredRows] = useState(rows);
  const [filterValue, setFilterValue] = useState('');

  const handleFilterChange = (event) => {
    const newFilterValue = event.target.value.toLowerCase();
    setFilterValue(newFilterValue);

    if (newFilterValue === "") {
      setFilteredRows(rows);
    } else {
      const filteredData = rows.filter(item =>
        item.provider_name.toLowerCase().includes(newFilterValue)
      );
      setFilteredRows(filteredData);
    }
  };

  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');
  const handleSortRequest = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const sortedRows = [...rows].sort((a, b) => {
    if (orderBy) {
      if (order === 'asc') {
        return a[orderBy] < b[orderBy] ? -1 : 1;
      } else {
        return a[orderBy] > b[orderBy] ? -1 : 1;
      }
    }
    return 0;
  });
  //   const [sortConfig, setSortConfig] = useState({ key: 'customer_id', direction: 'ascending' });
  // const handleSort = (key) => {
  //       let direction = 'ascending';
  //       if (sortConfig.key === key && sortConfig.direction === 'ascending') {
  //           direction = 'descending';
  //       }
  //       setSortConfig({ key, direction });
  //   };

    
  //   const sortedRows = React.useMemo(() => {
  //       let sortableItems = [...rows];
  //       if (sortConfig !== null) {
  //           sortableItems.sort((a, b) => {
  //               if (a[sortConfig.key] < b[sortConfig.key]) {
  //                   return sortConfig.direction === 'ascending' ? -1 : 1;
  //               }
  //               if (a[sortConfig.key] > b[sortConfig.key]) {
  //                   return sortConfig.direction === 'ascending' ? 1 : -1;
  //               }
  //               return 0;
  //           });
  //       }
  //       return sortableItems;
  //   }, [rows, sortConfig]);

  const rowsToDisplay = filterValue.length > 0 ? filteredRows : sortedRows;

  return (
    <>
      <div className="main">
        <Toaster></Toaster>
        <DeleteModel
          showModal={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onDelete={deleteProvider}
        />

        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <PageHeader title="Providers" crumb="Casino / Providers" />

              <div style={{ marginTop: "10px" }}>
                <div className="table_search">
                  <TextField
                    style={{ marginBottom: '10px', width: '25%' }}
                    placeholder="Enter provider name..."
                    type="text"
                    onChange={handleFilterChange}
                    value={filterValue}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <TableContainer component={Paper}>

                      <Table
                        className="c_table"
                        size="small"
                        aria-label="a dense table"
                        stickyHeader
                        aria-label="sticky table"
                        sx={{ minWidth: 500 }}
                        aria-label="custom pagination table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center" onClick={() => handleSortRequest('id')}>
                              Provider ID {orderBy === 'id' ? (order === 'asc' ? <ArrowUpward /> : <ArrowDownward />) : <ArrowUpward />}
                            </TableCell>
                            <TableCell align="center" onClick={() => handleSortRequest('provider_name')}>Provider Name {orderBy === 'provider_name' ? (order === 'asc' ? <ArrowUpward /> : <ArrowDownward />) : <ArrowUpward />}</TableCell>
                            <TableCell align="center" onClick={() => handleSortRequest('comission_rate')}>Comission Rate {orderBy === 'comission_rate' ? (order === 'asc' ? <ArrowUpward /> : <ArrowDownward />) : <ArrowUpward />}</TableCell>
                            <TableCell align="center">Api Url</TableCell>
                            <TableCell align="center">Gold Coin</TableCell>
                            <TableCell align="center">Saga Coin</TableCell>
                            <TableCell align="center">Allow Rewards</TableCell>
                            <TableCell align="center">Wager Rewards</TableCell>
                            <TableCell align="center">Menu Sort Order</TableCell>
                            <TableCell align="center">Menu</TableCell>
                            <TableCell align="center">Active</TableCell>
                            <TableCell align="center">Option</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rowsToDisplay.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                            <TableRow
                              key={row.id}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell align="center">{row.id}</TableCell>
                              <TableCell align="center">{row.provider_name}</TableCell>
                              <TableCell align="center">{row.comission_rate}</TableCell>
                              <TableCell align="center">{row.api_url}</TableCell>
                              <TableCell align="center">
                                <Switch

                                  checked={row.goldcoin !== 0}
                                  onChange={() => handleSwitchChange(row, 'goldcoin', row.goldcoin)}
                                />
                              </TableCell>
                              <TableCell align="center">
                                <Switch

                                  checked={row.sagacoin !== 0}
                                  onChange={() => handleSwitchChange(row, 'sagacoin', row.sagacoin)}
                                />
                              </TableCell>
                              <TableCell align="center">
                                <Switch

                                  checked={row.allow_rewards !== 0}
                                  onChange={() => handleSwitchChange(row, 'allow_rewards', row.allow_rewards)}
                                />
                              </TableCell>
                              <TableCell align="center">{row.wager_rewards}</TableCell>

                              <TableCell
                                align="center"
                                style={{ width: "20%" }}
                              >
                                <Form.Control
                                  value={row.menu_sort_order}
                                // onChange={(e) => setLimit(e.target.value)}
                                />
                              </TableCell>
                              <TableCell align="center">
                                <Switch

                                  checked={row.is_menu !== 0}
                                  onChange={() => handleSwitchChange(row, 'is_menu', row.is_menu)}
                                />
                              </TableCell>
                              <TableCell align="center">
                                <Switch

                                  checked={row.isactive !== 0}
                                  onChange={() => handleSwitchChange(row, 'isactive', row.isactive)}
                                />
                              </TableCell>

                              <TableCell align="center">
                                <EditIcon style={{ cursor: 'pointer' }} onClick={() => {
                                  setShow(true);
                                  setCreateData(true);
                                  setEditData(row);
                                }} />

                                <DeleteIcon style={{ cursor: 'pointer' }} onClick={() => handleDelete(row)} />
                              </TableCell>
                            </TableRow>
                          ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: "All", value: -1 },
                              ]}
                              colSpan={12}
                              count={rowsToDisplay.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                  <>
                    <Modal
                      show={show}
                      onHide={handleClose}
                      style={{ marginTop: "10%" }}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                          Manage Provider
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                            // controlId="providerName"
                            >
                              <Form.Label>Provide Name </Form.Label>
                              <Form.Control type="text" placeholder="Provide Name" value={providerName} onChange={(event) => {
                                setProvideName(event.target.value);
                              }} />
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                            // controlId="providerName"
                            >
                              <Form.Label>Commision Rate </Form.Label>
                              <Form.Control type="text" placeholder="Commision Rate" value={commisionRate} onChange={(event) => {
                                setCommisionRate(event.target.value);
                              }} />
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                            // controlId="providerName"
                            >
                              <Form.Label>
                                Api(Only editable by admin){" "}
                              </Form.Label>
                              <Form.Control type="text" placeholder="xxxxx" value={apiData} onChange={(event) => {
                                setApi(event.target.value);
                              }} />
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            <FormGroup>
                              <FormControlLabel
                                control={<Checkbox
                                  name="isCheckedGoldCoin"
                                  checked={checkboxes.isCheckedGoldCoin}
                                  onChange={handleCheckboxChange}

                                />}
                                label="Gold Coins"

                              />
                              <FormControlLabel
                                control={<Checkbox
                                  name="isCheckedSagaCoin"
                                  checked={checkboxes.isCheckedSagaCoin}
                                  onChange={handleCheckboxChange}
                                />}
                                label="Saga Coins"
                              />
                            </FormGroup>
                          </div>
                          <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                            // controlId="providerName"
                            >
                              <Form.Label>Wager Back Rewards Rate </Form.Label>
                              <Form.Control type="text" value={wagerBack} onChange={(event) => {
                                setWagerBack(event.target.value);
                              }} placeholder="xxxxx" />
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            <FormGroup>
                              <FormControlLabel
                                control={<Checkbox
                                  name="isCheckedAllowReward"
                                  checked={checkboxes.isCheckedAllowReward}
                                  onChange={handleCheckboxChange}
                                />}
                                label="Allow Rewards"
                              />
                            </FormGroup>
                          </div>

                          <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                            // controlId="providerName"
                            >
                              <Form.Label>Menu Sort Order: </Form.Label>
                              <Form.Control type="number" value={menuOrder} onChange={(event) => {
                                setMenuOrder(event.target.value);
                              }} placeholder="xxxxx" />
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            <FormGroup>
                              <FormControlLabel
                                control={<Checkbox
                                  name="isCheckedMenu"
                                  checked={checkboxes.isCheckedMenu}
                                  onChange={handleCheckboxChange} />}
                                label="Menu"
                              />
                              <FormControlLabel
                                control={<Checkbox name="isCheckedActive"
                                  checked={checkboxes.isCheckedActive}
                                  onChange={handleCheckboxChange} />}
                                label="Active"
                              />
                            </FormGroup>
                          </div>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          onClick={handleOk}
                          style={{
                            background: "#04631e",
                            borderColor: "#04631e",
                          }}
                        >
                          Apply
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginTop: "20px",
                }}
              >
                <Button
                  variant="primary"
                  style={{ background: "#04631e", borderColor: "#04631e" }}
                  onClick={() => {
                    setShow(true);
                    setEditData({})
                    setCreateData(true);
                  }}
                >
                  Add New Provider
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Provider;
